import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  avatar: props => ({
    border: '2px solid #004a83',
    height: theme.spacing(props.size),
    width: theme.spacing(props.size),
  }),
}));

function Logo({ id, size }) {
  const classes = useStyles({ size });
  return (
    <div className={classes.root}>
      <Avatar
        className={classes.avatar}
        alt="Team"
        src={`https://www-league.nhlstatic.com/builds/site-core/8d679dc125a67f8bf52f63a8cb3e70be14f173e9_1491511772/images/logos/team/current/team-${id}-dark.svg`}
      />
    </div>
  )
}

Logo.defaultProps = {
  size: 5,
}

export default Logo;
